import { OrganizationModel } from '../models/organization.model';
import { CollectionModel } from 'src/app/organizations/models/collection.model';
import { WidgetOptions } from 'src/app/publish/models/widget-options.model';
import { OrganizationUserModel } from '../models/organization-user.model';
import { OrganizationProfileModel } from '../models/organization-profile.model';

export class OrganizationsStateModel {
   
    organizations?: OrganizationModel[];
    organization?: OrganizationModel;
    collections?: CollectionModel[];

    organizationProfile?: OrganizationProfileModel;

    selectedOrganization?: OrganizationModel;
    selectedCollection?: CollectionModel;

    widgetURL?: string;
    widgetOptions?: WidgetOptions;

    appFeatures?: {
        offlinePkgGen?: boolean;
    };

    // loading state
    creating: boolean;
    updating: boolean;
    joining: boolean;
    inviting: boolean;
    loadingUsers: boolean;

    // organization users
    users: OrganizationUserModel[];
}
